module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_9.c971561a.png";